import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { Response } from '../../models/response.model';
import { CommonDataService } from './common-data.service';

export class DataService extends CommonDataService {
  constructor(endPoint: string, protected http: HttpClient) {
    super(endPoint);
  }

  get(resourceName: string, queryParams?: any,headers ?: any): Observable<any> {
    return this.http
      .get<Response<any>>(this.getFullUrl(resourceName), {
        params: queryParams,
        headers: headers
      })
      .pipe(map(this.emitData), catchError(this.handleError));
  }

  post(resourceName: string, resource: any = null): Observable<any> {
    const formData = resource ? this.parseToFormData(resource) : null;

    return this.http
      .post<Response<any>>(this.getFullUrl(resourceName), formData)
      .pipe(map(this.emitData), catchError(this.handleError));
  }

  put(resourceName: string, resource: any = null): Observable<any> {
    const formData = resource ? this.parseToFormData(resource) : null;

    return this.http
      .put<Response<any>>(this.getFullUrl(resourceName), formData)
      .pipe(map(this.emitData), catchError(this.handleError));
  }

  create(resource: any): Observable<any> {
    const formData = this.parseToFormData(resource);
    return this.http
      .post<Response<any>>(this.getFullUrl('save'), formData)
      .pipe(map(this.emitData), catchError(this.handleError));
  }

  update(resource: any): Observable<any> {
    const formData = this.parseToFormData(resource);

    return this.http
      .post<Response<any>>(this.getFullUrl('update'), formData)
      .pipe(map(this.emitData), catchError(this.handleError));
  }

  delete(resourceName: string): Observable<void> {
    return this.http
      .delete<Response<any>>(this.getFullUrl(resourceName))
      .pipe(
        map(this.emitData),
        catchError(this.handleError)
      );
  }

  export(options: {
    pageSize?: number;
    pageIndex?: number;
    sortColumn?: string;
    sortType?: string;
    query?: string;
  }, queryParams?: any,isAdmin = false): Observable<any> {
    let paramQuery = {
      per_page: options.pageSize ?? environment.defaultPaginator.pageSize,
      page: options?.pageIndex
        ? options.pageIndex + 1
        : environment.defaultPaginator.pageIndex + 1,
      'sort_keys[]': options.sortColumn ?? '',
      'sort_dir[]': options.sortType ?? '',
      search: options.query ?? ''
    };
    return this.http.get(this.getFullUrl('export',isAdmin), { params: { ...paramQuery , ...queryParams}, responseType: 'blob' });

  }
}
